/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".day-green[_ngcontent-%COMP%]{color:green}.day-yellow[_ngcontent-%COMP%]{color:#e6c210}.day-orange[_ngcontent-%COMP%]{color:#a5700d}.day-red[_ngcontent-%COMP%]{color:red}.day-black[_ngcontent-%COMP%]{color:#000}"];
export { styles as styles };
